import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/20/solid';
function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
export default function Tabs({ tabs, children, onChange, className, dataTestId, }) {
    return (React.createElement(Tab.Group, { as: "div", "data-testid": dataTestId, onChange: onChange },
        React.createElement(Tab.List, { "data-testid": "undefined-387985cb", className: classNames('border-b border-gray-200', className) }, ({ selectedIndex }) => (React.createElement("div", { "data-testid": "div-624e4f32", className: "-mb-px flex space-x-8" }, tabs.map((tab, i) => (React.createElement(Tab, { key: tab.name, disabled: tab.disabled, className: ({ selected }) => classNames(selected
                ? 'border-green-500 text-green-600'
                : 'border-transparent hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm', tab.disabled
                ? 'cursor-not-allowed text-gray-400 pointer-events-none'
                : 'text-gray-500') },
            React.createElement("div", { "data-testid": `div-a5e130b3-${i}`, className: "flex justify-between space-x-4" },
                React.createElement("span", { "data-testid": tab.id }, tab.name),
                i === selectedIndex && tab.closeable && (React.createElement(XMarkIcon, { className: "w-4 h-4" }))))))))),
        React.createElement(Tab.Panels, { "data-testid": "undefined-d5d97efc", className: "mt-4" }, children)));
}
Tabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
    })),
    children: PropTypes.node,
};
